import React, { createContext, useState, useContext, useEffect } from 'react';

const DebugContext = createContext();

export const useDebug = () => useContext(DebugContext);

export const DebugProvider = ({ children }) => {
  const [logs, setLogs] = useState([]);

  const log = (logEntry) => {
    setLogs((prevLogs) => [...prevLogs, { ...logEntry, timestamp: new Date() }]);
  };

  useEffect(() => {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const [url, config] = args;
      const request = {
        url: url.toString(),
        method: config?.method || 'GET',
        headers: config?.headers,
        body: config?.body,
      };
      log({ type: 'request', data: request });

      try {
        const response = await originalFetch(...args);
        const responseClone = response.clone();
        const responseBody = await responseClone.json().catch(() => 'Could not parse JSON');

        const res = {
          url: response.url,
          status: response.status,
          statusText: response.statusText,
          headers: Object.fromEntries(response.headers.entries()),
          body: responseBody,
        };
        log({ type: 'response', data: res });

        return response;
      } catch (error) {
        log({ type: 'error', data: error });
        throw error;
      }
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  const clearLogs = () => setLogs([]);

  return (
    <DebugContext.Provider value={{ logs, clearLogs }}>
      {children}
    </DebugContext.Provider>
  );
};
